import CalcularPrecioPais from "../preciosPaises/calcularPrecioPais";
import ObtenerMultiplicador from "../preciosPaises/obtenerMultiplicador.js";

export function CalculateFinalPriceTotal(s, services) {
  // console.log("Servicio:", s.servicio?.na  me || s.servicio);
  // console.log("ID:", s.id);
  
  let precioBase = 0;

  if (s.customPriceActive) {
    if (typeof s.customPrice === 'number' && typeof s.numeroItems === 'number') {
      precioBase = s.customPrice * s.numeroItems;
    } else {
      //console.warn("customPrice o numeroItems inválido:", s.customPrice, s.numeroItems);
    }
  } else if (s.servicio && s.planServicio) {
    const servicioInfo = services.find((e) => e.id === s.servicio.id);
    if (!servicioInfo) {
      //console.warn("Servicio no encontrado:", s.servicio.name);
    } else {
      const planInfo = servicioInfo.preciosUnitarios.find(
        (ev2) => ev2.plan.id === s.planServicio.id
      );
      if (!planInfo) {
        //console.warn("Plan no encontrado:", s.planServicio.id);
      } else if (typeof planInfo.precio === 'number' && typeof s.numeroItems === 'number') {
        precioBase = planInfo.precio * s.numeroItems;
      } else {
        //console.warn("Precio o número de items inválido:", planInfo.precio, s.numeroItems);
      }
    }
  }

  // Paso 2: Calcular descuento
  let montoDescuento = 0;
  if (s.tipoDescuento === "Porcentaje") {
    montoDescuento = precioBase * (s.montoDescuento / 100);
  } else if (s.tipoDescuento === "Fijo") {
    montoDescuento = s.montoDescuento * s.numeroItems;
  }

  // console.log("Discount")
  // console.log(montoDescuento)

  // console.log(`Precio base: ${precioBase}, Descuento: ${montoDescuento}`);
  // console.log(`Precio final: ${precioBase - montoDescuento}`)

  // Paso 3: Retornar total

  // console.log("Precio base: " + precioBase + " - Descuento: " + montoDescuento + " = Total: " + (precioBase - montoDescuento))
  return precioBase - montoDescuento;
}

export function CalculateFinalPriceTotalWithPagoUnico(s, services, cotizacionData, paises, tipoCambio) {
  // console.log("Servicio:", s.servicio?.name || s.servicio);
  // console.log("ID:", s.id);
  
  let precioBase = 0;
  let numeroItemsCalculado = s.numeroItems;

  // Lógica especial para pagoUnico
  if (s.pagoUnico) {
    // Si tiene pagoUnico activado, contar TODOS los items porque todo el dinero entró en ese mes
    numeroItemsCalculado = s.numeroItems;
  } else {
    // Si no tiene pagoUnico, contar SOLO 1 item porque solo entra el dinero de ese mes
    numeroItemsCalculado = 1;
  }

  if (s.customPriceActive) {
    if (typeof s.customPrice === 'number' && typeof numeroItemsCalculado === 'number') {
      precioBase = s.customPrice * numeroItemsCalculado;
    } else {
      //console.warn("customPrice o numeroItems inválido:", s.customPrice, numeroItemsCalculado);
    }
  } else if (s.servicio && s.planServicio) {
    const servicioInfo = services.find((e) => e.id === s.servicio.id);
    if (!servicioInfo) {
      //console.warn("Servicio no encontrado:", s.servicio.name);
    } else {
      const planInfo = servicioInfo.preciosUnitarios.find(
        (ev2) => ev2.plan.id === s.planServicio.id
      );
      if (!planInfo) {
        //console.warn("Plan no encontrado:", s.planServicio.id);
      } else if (typeof planInfo.precio === 'number' && typeof numeroItemsCalculado === 'number') {
        precioBase = planInfo.precio * numeroItemsCalculado;
      } else {
        //console.warn("Precio o número de items inválido:", planInfo.precio, numeroItemsCalculado);
      }
    }
  }

  // Calcular el precio según el país solo si no es customPrice
  const precioConPais = s?.customPriceActive
    ? precioBase
    : CalcularPrecioPais({
        precio: precioBase,
        multiplicador: ObtenerMultiplicador({
          pais: cotizacionData?.cliente?.pais ? cotizacionData?.cliente?.pais : cotizacionData?.lead?.country,
          paises: paises
        })
      });

  // Paso 2: Calcular descuento
  let montoDescuento = 0;
  if (s.tipoDescuento === "Porcentaje") {
    montoDescuento = precioConPais * (s.montoDescuento / 100);
  } else if (s.tipoDescuento === "Fijo") {
    // Para descuento fijo, usar el numeroItemsCalculado
    montoDescuento = s.montoDescuento * numeroItemsCalculado;
  }

  // console.log("Discount")
  // console.log(montoDescuento)

  // console.log(`Precio base: ${precioConPais}, Descuento: ${montoDescuento}`);
  // console.log(`Precio final: ${precioConPais - montoDescuento}`)

  // Paso 3: Retornar total

  // console.log("Precio base: " + precioConPais + " - Descuento: " + montoDescuento + " = Total: " + (precioConPais - montoDescuento))
  return precioConPais - montoDescuento;
}
